import React from "react";
import { Icon } from "../../../core/Icon";
import { NavLink } from "react-router-dom";
export const PasswordSet = () => {
    return (React.createElement("div", { className: "process-master-challenge text-center" },
        React.createElement("div", null,
            React.createElement(Icon, { c: ['tick-circle', 64, 64, 'success-icon'] }),
            React.createElement("h1", { className: "mb-8" }, "M\u016F\u017Eete za\u010D\u00EDt pou\u017E\u00EDvat nov\u00E9 heslo."),
            React.createElement("p", null, "Nov\u00E9 heslo bylo \u00FAsp\u011B\u0161n\u011B nastaveno. Pokra\u010Dujte pros\u00EDm na p\u0159ihla\u0161ovac\u00ED formul\u00E1\u0159."),
            React.createElement(NavLink, { to: "/cs/proces/prihlaseni-uzivatele", className: "primary-button" },
                React.createElement("span", { className: "text" }, "P\u0159ihl\u00E1sit se")))));
};
